import { Box, styled, Typography } from '@mui/material'
import { TableColumn } from 'types/types'
import { AccessTag } from './Users.styled'
import { TableActionConfig } from '../../components/Table/types'
import { TableActions } from '../../components/Table/TableActions'

const StyledAccessLabelContainerStyles = styled(Box)`
  max-width: 400px;
  overflow: auto;
  display: flex;
`

export const usersTableColumns = <T,>({
  actions,
}: {
  actions: TableActionConfig<T>[]
}): TableColumn[] => [
  {
    id: 'name',
    label: 'First Name',
    minWidth: 170,
    filterParams: { filterVariant: 'string' },
    sortable: true,
  },
  {
    id: 'surname',
    label: 'Last Name',
    minWidth: 100,
    filterParams: { filterVariant: 'string' },
    sortable: true,
  },
  {
    id: 'email',
    label: 'Email',
    minWidth: 170,
    align: 'left',
    sortable: true,
    format: (value) => (
      <Typography
        sx={{
          color: (theme) => theme.palette.custom.link,
        }}
      >
        {value}
      </Typography>
    ),
    filterParams: { filterVariant: 'string' },
  },
  {
    id: 'access',
    label: 'Access',
    minWidth: 170,
    align: 'left',
    format: (_, row) => {
      return (
        <StyledAccessLabelContainerStyles>
          {row?.company_roles?.map((item, index) => (
            <AccessTag key={index}>
              {item?.company_name}, {item?.role_name}{' '}
            </AccessTag>
          ))}
        </StyledAccessLabelContainerStyles>
      )
    },
  },
  {
    id: 'actions',
    label: '',
    minWidth: 170,
    align: 'right',
    format: (_, row: T) => <TableActions actions={actions} row={row} />,
  },
]
